import { useLanguage } from '../../contexts/LanguageContext';

const PRIORITY_STYLES = {
  critica: 'bg-[#FF3B30]/20 text-[#FF3B30] border-[#FF3B30]/50',
  alta: 'bg-[#FF9F0A]/20 text-[#FF9F0A] border-[#FF9F0A]/50',
  media: 'bg-[#FFD60A]/20 text-[#FFD60A] border-[#FFD60A]/50',
  bassa: 'bg-[#32D74B]/20 text-[#32D74B] border-[#32D74B]/50',
};

const STATUS_STYLES = {
  nuova: 'bg-[#FF3B30]/20 text-[#FF3B30] border-[#FF3B30]/50',
  in_corso: 'bg-[#FF9F0A]/20 text-[#FF9F0A] border-[#FF9F0A]/50',
  assegnata: 'bg-[#0A84FF]/20 text-[#0A84FF] border-[#0A84FF]/50',
  risolta: 'bg-[#32D74B]/20 text-[#32D74B] border-[#32D74B]/50',
  chiusa: 'bg-[#5C5C5C]/20 text-[#6B8AB5] border-[#5C5C5C]/50',
};

export function PriorityBadge({ priority }) {
  const { t } = useLanguage();
  const style = PRIORITY_STYLES[priority] || PRIORITY_STYLES.media;
  return (
    <span className={`inline-flex items-center px-2 py-1 text-[10px] font-mono uppercase tracking-wider border ${style}`} data-testid={`priority-badge-${priority}`}>
      {t(priority)}
    </span>
  );
}

export function StatusBadge({ status }) {
  const { t } = useLanguage();
  const style = STATUS_STYLES[status] || STATUS_STYLES.nuova;
  return (
    <span className={`inline-flex items-center px-2 py-1 text-[10px] font-mono uppercase tracking-wider border ${style}`} data-testid={`status-badge-${status}`}>
      {t(status)}
    </span>
  );
}

export function PrioritySelector({ selected, onSelect }) {
  const { t } = useLanguage();
  const priorities = ['critica', 'alta', 'media', 'bassa'];
  const colors = {
    critica: '#FF3B30',
    alta: '#FF9F0A',
    media: '#FFD60A',
    bassa: '#32D74B',
  };

  return (
    <div className="flex gap-2 flex-wrap" data-testid="priority-selector">
      {priorities.map((p) => (
        <button
          key={p}
          onClick={() => onSelect(p)}
          className={`flex items-center gap-2 px-4 py-2 border text-xs font-bold uppercase tracking-widest transition-all ${
            selected === p
              ? `border-[${colors[p]}] bg-[${colors[p]}]/20`
              : 'border-[#B8D4E8] bg-white hover:border-[#FF3B30]/50'
          }`}
          style={selected === p ? { borderColor: colors[p], backgroundColor: `${colors[p]}20` } : {}}
          data-testid={`priority-${p}`}
        >
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors[p] }} />
          {t(p)}
        </button>
      ))}
    </div>
  );
}
